import { InputHTMLAttributes } from "react";

export default function TextIpunt(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input 
      className="text-input separate-top" 
      { ...props }
    />
  );
}